export default class Profile {
    constructor(client) {
        this.url = '/profile';
        this.client = client;
    }
    Get() {
        return this.client.get(this.url);
    }
}
